/**
 * Labels for the stored codes on a camp or clinic (typed event).
 *
 * The staff form stores a skill level code ("intermediate", "all") and the
 * type is free text that seed data and older records hold as a code
 * ("day_camp", "skills"). The public detail page showed those codes as they
 * were stored (2026-10-10). Both screens read the labels from here.
 */

export const SKILL_LEVEL_OPTIONS = [
  { value: "beginner", label: "Beginner" },
  { value: "intermediate", label: "Intermediate" },
  { value: "advanced", label: "Advanced" },
  { value: "all", label: "All Levels" },
] as const;

/** "intermediate" -> "Intermediate", "all" -> "All Levels". Unknown text is tidied, never dropped. */
export function skillLevelLabel(value: string | null | undefined): string {
  const v = String(value ?? "").trim();
  if (!v) return "";
  const known = SKILL_LEVEL_OPTIONS.find((o) => o.value === v.toLowerCase());
  return known ? known.label : humanizeCode(v);
}

/** A camp or clinic type: "day_camp" -> "Day Camp", "skills" -> "Skills". Typed words are kept as typed. */
export function typedEventTypeLabel(value: string | null | undefined): string {
  const v = String(value ?? "").trim();
  if (!v) return "";
  return humanizeCode(v);
}

/** A code-looking value (lowercase, underscores) becomes words; anything else is returned as is. */
function humanizeCode(v: string): string {
  if (!/^[a-z0-9_-]+$/.test(v)) return v;
  return v
    .split(/[_-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
